module.exports = __webpack_public_path__ + "img/logo_dark-1x.a35f6b57.jpg";